import React, { useEffect, useState, memo } from 'react';
export const AnnouncementBar = memo(function AnnouncementBar() {
  const [currentBanner, setCurrentBanner] = useState(0);
  const banners = ['Summer Offers - DISCOUNTS UP TO 80% | Limited time!', 'Free Shipping on Orders Over $50 | Shop Now', 'New Arrivals - Check Out Our Latest Products'];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBanner(prev => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return <div className="bg-blue-50 text-gray-800" data-id="element-2573" data-mp="ve3m7uubowzi">
      <div className="container mx-auto px-4" data-id="element-2574" data-mp="10cy32r8qcbgz">
        <div className="relative h-9 overflow-hidden" data-id="element-2575" data-mp="10b3jbg972peh">
          {banners.map((text, index) => <div key={index} className={`absolute inset-0 flex items-center justify-center text-center text-sm font-medium transition-opacity duration-500 ${currentBanner === index ? 'opacity-100' : 'opacity-0'}`} data-id="element-2576" data-mp="15dcd2etw5vhn" data-mpi={index}>
              {text}
            </div>)}
        </div>
      </div>
      <div className="bg-gradient-to-r from-[#fdc300] to-blue-200 h-0.5" data-id="element-2577" data-mp="108tefr9k3ea6"></div>
    </div>;
});